import { NotificationReadModel, NotificationType } from '@/client/services/api/graphql/gql/graphql';

import type { AssignmentFormData } from '../../../types/assignmentTypes';
import NotificationsListItem from '../../../notifications/NotificationsListItem';
import { Stack } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { useNotificationBuilderStore } from '../../state/AssignmentNotificationBuilderStore';

export default function AssignmentNotificationsList() {
  const { setActiveEditNotificationId, setNotificationBuilderActive } =
    useNotificationBuilderStore();
  const { watch, setValue } = useFormContext<AssignmentFormData>();

  const { settings } = watch();

  const { reminderMessages, nonReminderMessages, overdueMessages } = settings;

  const allNotifications = [...reminderMessages, ...nonReminderMessages, ...overdueMessages];

  const handleRemoveNotification = (message: NotificationReadModel) => {
    const notificationType = message.type;

    if (
      notificationType === NotificationType.AssignmentReminderAssignee ||
      notificationType === NotificationType.AssignmentReminderEscalator
    ) {
      setValue(
        'settings.reminderMessages',
        reminderMessages.filter((rMessage) => rMessage.message.id !== message.id),
      );

      return;
    }

    if (notificationType === NotificationType.AssignmentOverdueAssignee) {
      setValue(
        'settings.overdueMessages',
        overdueMessages.filter((odMessage) => odMessage.message.id !== message.id),
      );

      return;
    }

    setValue(
      'settings.nonReminderMessages',
      nonReminderMessages.filter((nrMessage) => nrMessage.id !== message.id),
    );
  };

  return (
    <Stack spacing={4}>
      {allNotifications.map((notification) => {
        const id = 'message' in notification ? notification.message.id : notification.id;

        return (
          <NotificationsListItem
            key={id}
            notification={notification}
            variant="warmNeutral"
            onEdit={(message) => {
              setActiveEditNotificationId(message.id);
              setNotificationBuilderActive(true);
            }}
            onRemove={(e, message) => {
              e.stopPropagation();
              handleRemoveNotification(message);
            }}
          />
        );
      })}
    </Stack>
  );
}
